var _filter, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppropriatenessAssessmentQuestionTen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-labelledby": titleId,
    width: 84,
    height: 83,
    viewBox: "0 0 84 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "brightness"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", null, /*#__PURE__*/React.createElement("feFuncR", {
    type: "linear",
    slope: 0.65
  }), /*#__PURE__*/React.createElement("feFuncG", {
    type: "linear",
    slope: 0.65
  }), /*#__PURE__*/React.createElement("feFuncB", {
    type: "linear",
    slope: 0.65
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.594 83C64.5658 83 83.1881 64.4198 83.1881 41.5C83.1881 18.5802 64.5658 0 41.594 0C18.6223 0 0 18.5802 0 41.5C0 64.4198 18.6223 83 41.594 83Z",
    fill: "#242D33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1406 42.625V30.2344C51.1406 25.1939 47.0404 21.0938 42 21.0938C36.9596 21.0938 32.8594 25.1939 32.8594 30.2344V42.625H26.7656V30.2344C26.7656 21.8346 33.6003 15 42 15C50.3997 15 57.2344 21.8346 57.2344 30.2344V42.625H51.1406Z",
    fill: "#E6E8EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1406 30.2344V42.625H57.2344V30.2344C57.2344 21.8346 50.3997 15 42 15V21.0938C47.0404 21.0938 51.1406 25.1939 51.1406 30.2344Z",
    fill: "#E6E8EC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    filter: "url(#brightness)",
    d: "M57.2344 67H26.7656C24.2455 67 22.1953 64.9499 22.1953 62.4297V44.1484C22.1953 41.6283 24.2455 39.5781 26.7656 39.5781H57.2344C59.7545 39.5781 61.8047 41.6283 61.8047 44.1484V62.4297C61.8047 64.9499 59.7545 67 57.2344 67Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2344 39.5781H42V67H57.2344C59.7545 67 61.8047 64.9499 61.8047 62.4297V44.1484C61.8047 41.6283 59.7545 39.5781 57.2344 39.5781Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5703 50.2422C46.5703 47.722 44.5202 45.6719 42 45.6719C39.4798 45.6719 37.4297 47.722 37.4297 50.2422C37.4297 52.2268 38.7069 53.902 40.4766 54.5328V59.3828C40.4766 60.2249 41.1579 60.9062 42 60.9062C42.8421 60.9062 43.5234 60.2249 43.5234 59.3828V54.5328C45.2931 53.902 46.5703 52.2268 46.5703 50.2422Z",
    fill: "#333F48"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5234 59.3828V54.5328C45.2931 53.902 46.5703 52.2268 46.5703 50.2422C46.5703 47.722 44.5202 45.6719 42 45.6719V60.9062C42.8421 60.9062 43.5234 60.2249 43.5234 59.3828Z",
    fill: "#465A61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppropriatenessAssessmentQuestionTen);
export default __webpack_public_path__ + "static/media/AppropriatenessAssessmentQuestionTen.61d57074ade357838f73b4d2ded217f5.svg";
export { ForwardRef as ReactComponent };